function pad(n) {return (n<10 ? '0'+n : n);}

export const inArray = (needle, haystack) => {
	var length = haystack.length;
	for(var i = 0; i < length; i++) {
		if(haystack[i] == needle) return true;
	}
	return false;
}

export const getMonthYear = (date) => {
	//console.log(date);
	var year = date.getFullYear();

	var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
	var month = months[date.getMonth()] + ' ' + year;

	return month;
}

export const getMonthYearTimestamp = (timestamp) => {
	var date = new Date(timestamp * 1000);
	return getMonthYear(date);
}

export const dateFormat = (date) => {
	var year = date.getFullYear();

	//var month = date.getMonth()+1;
	var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
	var month = months[date.getMonth()];

	var date = date.getDate();

	//var date = pad(date) + '.' + pad(month) + '.' + year ;
	var date = pad(date) + '.' + pad(month);

	return date;
}
// export const dateFormatTimeTimestamp = (timestamp) => {
// 	var a = new Date(timestamp * 1000);
// 	var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
// 	var year = a.getFullYear();
// 	var month = months[a.getMonth()];
// 	var date = a.getDate();
// 	var hour = a.getHours();
// 	var min = a.getMinutes();
// 	var sec = a.getSeconds();
// 	var format_date = pad(date) + ' ' + pad(month) + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
// 	return format_date;
// }

export const dateFormatTimestamp = (timestamp) => {
	var date = new Date(timestamp * 1000);
	return dateFormat(date);
}

export const dateFormatToday = () => {
	var date = new Date();
	return dateFormat(date);
}

export const dateFormatYesterday = () => {
	var date = new Date();
	date.setDate(date.getDate() - 1);
	return dateFormat(date);
}

export const smartDateFormatTimestamp = (timestamp) => {

	var date = new Date(timestamp * 1000);
	//console.log(date);
	if(date){
		date = dateFormat(date);
		//console.log(date);
		//console.log(dateFormatToday());
		if (date == dateFormatToday())
			date = 'today';
		if (date == dateFormatYesterday())
			date = 'yesterday';
	}
	return date;
}

export const dateFormatNotifications = (timestamp) => {
	var date = new Date(timestamp * 1000);
	var year = date.getFullYear();

	//var month = date.getMonth()+1;
	var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
	var month = months[date.getMonth()];

	var date = date.getDate();

	//var date = pad(date) + '.' + pad(month) + '.' + year ;
	var date = pad(date) + ' ' + pad(month);

	return date;
}

// notifications
export const getFullDateTimestamp = (timestamp) => {
	const options = { year: 'numeric', month: 'long', day: 'numeric' };
	var date = new Date(timestamp * 1000);
	date = date.toLocaleDateString("en-US", options);
	return date;
}

export const formatDate = (timestamp) => {
	const options = { year: 'numeric', month: 'long', day: 'numeric' };
	var date = new Date(timestamp);
	date = date.toLocaleDateString("en-US", options);
	return date;
}
